/**
 * Save manager module
 *
 * This module is used for save content
 *
 */

 /* eslint no-prototype-builtins: "off" */

'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const Mediator = require('./../../../core/mediator');

const ContentContainer = require('./ContentContainer');
const ContentRepository = require('./../repository/ContentRepository');
const ContentSet = require('./../model/ContentSet');

let SaveManager = {};

/**
 * Save all updated content
 *
 * @returns {Promise} promise
 */
SaveManager.save = function() {
    let self = this;
    let promises = [];
    let isDrafted = false;

    _.forEach(ContentContainer.getAll(), function(content) {
        if (content.updated && content.isSavable()) {
            isDrafted = true;
            self.commit(content);
            promises.push(self.push(content));
        }
    });

    if (isDrafted) {
        Mediator.publish('content:save');
    }

    return jQuery.when.apply(undefined, promises).promise();
};

/**
 * Build revision with current elements
 *
 * @param  {object} content
 * @returns {object} SaveManager
 */
SaveManager.commit = function(content) {
    if (content instanceof ContentSet) {
        if (content.$ instanceof jQuery) {
            let children = content.getChildren();
            let elements = [];

            _.forEach(children, function(value) {
                elements.push({
                    'uid': value.uid,
                    'type': value.type,
                });
            });

            content.setElements(elements);
        }
    }

    return this;
};

/**
 * Merge elements and parameters from revision
 * to the content
 *
 * @param  {object} content
 * @returns {object} content
 */
SaveManager.merge = function(content) {
    let revision = content.revision;
    let elements = revision.elements;
    let parameters = revision.parameters;

    if (content.data) {
        if (null !== elements) {
            if (content.isContentSet()) {
                content.data.elements = elements;
            } else {
                _.forEach(elements, function(value, key) {
                    if (content.data.elements.hasOwnProperty(key)) {
                        content.data.elements[key] = value;
                    }
                });
            }
        }

        if (null !== parameters) {
            _.forEach(parameters, function(value, key) {
                if (content.data.parameters.hasOwnProperty(key)) {
                    content.data.parameters[key].value = value;
                }
            });
        }
    }

    revision.removeElements();
    revision.removeParameters();

    content.setUpdated(false);

    return content;
};

/**
 * Push revision to database
 *
 * @param  {object} content
 * @returns {Promise} promise
 */
SaveManager.push = function(content) {
    let self = this;
    let dfd = jQuery.Deferred();

    ContentRepository.save(content.revision).done(function() {
        self.merge(content);

        dfd.resolve();
    });

    return dfd.promise();
};

module.exports = SaveManager;
